export const brandProfileMatchTypes = {
  NOT_MATCHED: '6', // Comes from web.php
}
